import { Box } from '@mui/material';
import { type FC, type ReactElement, useContext } from 'react';

import { SlabContext } from '@core/context/SlabContext';
import Enums from '@core/types/api/Enums';
import type { FileEntityType } from '@core/types/file';
import { hasValue } from '@core/utils/equality';

import { CloneFilesList } from './CloneFilesList';
import { EntityFilesPanel } from './EntityFilesPanel';
import { FileUploadArea } from './FileUploadArea';
import type { FileUploadsManager } from './useFileUploads';

type Props = {
  entityType: FileEntityType;
  entityId: string | null;
  manager: FileUploadsManager;
};

export const EntityFilesSection: FC<Props> = ({ entityType, entityId, manager }): ReactElement => {
  const ctx = useContext(SlabContext);
  const canMarkSensitive = ctx.userInfo.hasPermissions([Enums.Permission.CanViewSensitiveFiles]);

  if (hasValue(entityId)) {
    return <EntityFilesPanel entityType={entityType} entityId={entityId} />;
  }

  const { cloneSourceEntityId } = manager;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {hasValue(cloneSourceEntityId) && (
        <CloneFilesList
          entityType={entityType}
          sourceEntityId={cloneSourceEntityId}
          manager={manager}
        />
      )}
      <FileUploadArea manager={manager} canMarkSensitive={canMarkSensitive} />
    </Box>
  );
};
